import { createAction } from 'redux-act';

import Hours from '@/models/interfaces/Hours';

export interface CreateDefaultHoursPayload {
  placeUuid: string;
}
export const createDefaultHours = createAction<CreateDefaultHoursPayload>('CREATE_DEFAULT_HOURS');

export interface DefaultHoursCreatedPayload {
  hours: Hours;
}
export const defaultHoursCreated = createAction<DefaultHoursCreatedPayload>('DEFAULT_HOURS_CREATED');

export interface DefaultHoursCreationFailedPayload {
  placeUuid: string;
}
export const defaultHoursCreationFailed = createAction<DefaultHoursCreationFailedPayload>('DEFAULT_HOURS_CREATION_FAILED');
